/**
 * PerformanceIcon - Ícone de raio/bolt
 * @module components/icons/PerformanceIcon
 *
 * US-020: Redesign da Página Assessment Selection
 */

export interface IconProps {
  className?: string;
}

export function PerformanceIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      data-testid="performance-icon"
      aria-hidden="true"
    >
      <path
        d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
